// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ru from './locales/ru.json';
import ca from './locales/ca.json';
import zh from './locales/zh.json';

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    ru: { translation: ru },
    ca: { translation: ca },
    zh: { translation: zh }
  },
  lng: localStorage.getItem('appLanguage') || 'es', // idioma inicial
  fallbackLng: 'es',
  interpolation: { escapeValue: false }
});

export default i18n;